module.exports = __webpack_public_path__ + "img/bold-assign.aa47cf54.svg";